import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Checkbox } from 'semantic-ui-react';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { updateSelectedSite, updateSelectAll } from '../state/report/actions';

class SiteGridContainer extends Component {
  getIsChecked = siteId => {
    return this.props.selectedSites.includes(siteId);
  };

  getIsAllChecked = () => {
    const { selectedSites, sites } = this.props;
    return selectedSites.length > 0 && selectedSites.length === sites.length;
  };

  render() {
    return (
      <ReactTable
        data={this.props.data}
        minRows={5}
        defaultFilterMethod={caseInsensitiveFilter}
        columns={[
          {
            Header: 'Site ID',
            accessor: 'Id',
            maxWidth: 100,
            filterable: true,
          },
          {
            Header: 'Description',
            accessor: 'Description',
            filterable: true,
          },
          {
            Header: () => {
              return (
                <Checkbox
                  checked={this.getIsAllChecked()}
                  onClick={(e, data) => {
                    this.props.updateSelectAll(data.checked);
                  }}
                />
              );
            },
            accessor: 'Checked',
            resizable: false,
            sortable: true,
            maxWidth: 80,
            Cell: ({ original }) => {
              return (
                <div style={styles.checkboxCell}>
                  <Checkbox
                    checked={this.getIsChecked(original.Id)}
                    onClick={(e, data) => {
                      this.props.updateSelectedSite(data.checked, original.Id);
                    }}
                  />
                </div>
              );
            },
          },
        ]}
      />
    );
  }
}

const styles = {
  checkboxCell: {
    textAlign: 'center',
  },
};

const mapStateToProps = state => {
  const { report } = state.ReimbursementReportState;

  return { selectedSites: report.selectedSites, sites: report.sites };
};

export const SiteGrid = withRouter(
  connect(
    mapStateToProps,
    { updateSelectedSite, updateSelectAll }
  )(SiteGridContainer)
);



// WEBPACK FOOTER //
// ./src/pages/reimbursement/components/SiteGrid.js